
const RouterUtils = {};



RouterUtils.getRouterObjByName = function (menuList, name) {
  if (!name || !menuList || !menuList.length) {
    return null;
  }
  for (let item of menuList) {
    if (item.routeUrl === name) {
      return item;
    }
  }
  return null;
};

export default RouterUtils;



// WEBPACK FOOTER //
// ./src/libs/utils/RouterUtils.js